module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("营业中店铺数")]), _vm._v(" "), _c('p', {
    staticClass: "mt10"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.shopCount.finished_task))]), _vm._v("家\n                ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("开店中店铺数")]), _vm._v(" "), _c('p', {
    staticClass: "mt10"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.shopCount.unfinished_task))]), _vm._v("家\n                ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("今日订单数")]), _vm._v(" "), _c('p', {
    staticClass: "mt10"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.summary.totalNumber || 0))]), _vm._v("单\n                ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("本月订单数")]), _vm._v(" "), _c('p', {
    staticClass: "mt10"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.summary1.totalNumber || 0))]), _vm._v("单\n                ")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pt20 pb20"
  }, [_c('div', [_c('el-popover', {
    attrs: {
      "placement": "right",
      "width": "400",
      "trigger": "click"
    }
  }, [_c('div', [_c('p', [_vm._v("为确保高效进件，请在进件前先让商户提供以下完整信息：")]), _vm._v(" "), _c('p', [_vm._v("1.邮箱账号、银行卡信息（包括卡号、账户名、开户行名称、支行名称和支行所在区域）")]), _vm._v(" "), _c('p', [_vm._v("2.营业执照照片（确保无水印、清晰）、身份证正反面照片（确保无水印、清晰）")]), _vm._v(" "), _c('p', [_vm._v("3.门店信息（包括门店名称、所在区域和详细地址、门头照片、内景照片）")]), _vm._v(" "), _c('p', [_vm._v("4.其他：店铺所在地租赁协议或产权证明、已经签署好的合作确认函照片")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary",
      "size": "mini"
    },
    slot: "reference"
  }, [_vm._v("进件说明")])], 1)], 1)]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "营业中店铺",
      "name": "1"
    }
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shop_id", $$v)
      },
      expression: "queryForm.shop_id"
    }
  }, _vm._l((_vm.shops), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺手机号",
      "prop": "mp"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号",
      "maxlength": "11"
    },
    model: {
      value: (_vm.queryForm.mp),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "mp", $$v)
      },
      expression: "queryForm.mp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "进件状态",
      "prop": "audit_status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.audit_status),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "audit_status", $$v)
      },
      expression: "queryForm.audit_status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "未进件",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审核中",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分账中",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审核失败",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待激活",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "签约中",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "进件成功",
      "value": "5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryForm.page = 1;
        _vm.fetchData()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shop_name",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mp",
      "label": "店铺手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "合作时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remit_period",
      "label": "打款周期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.remit_period) ? _c('span', [_vm._v("T + " + _vm._s(scope.row.remit_period))]) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "audit_status",
      "label": "进件状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.audit_status == -1) ? _c('span', [_vm._v("未进件")]) : (scope.row.audit_status == 1) ? _c('span', [_vm._v("分账中")]) : (scope.row.audit_status == 2) ? _c('span', [_vm._v("审核失败")]) : (scope.row.audit_status == 3) ? _c('span', [_vm._v("待激活")]) : (scope.row.audit_status == 4) ? _c('span', [_vm._v("签约中")]) : (scope.row.audit_status == 5) ? _c('span', [_vm._v("进件成功")]) : _c('span', [_vm._v("审核中")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.audit_status == -1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.bindKq(scope.row)
            }
          }
        }, [_vm._v("进件")]) : (scope.row.audit_status == 2) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.bindKq(scope.row)
            }
          }
        }, [_vm._v("修改")]) : _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.bindKq(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.page,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "开店中店铺",
      "name": "2"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shop_name",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mp",
      "label": "店铺手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status_tip",
      "label": "开店进度"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.page,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f559a4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/saas/basic/shopInfo.vue
// module id = 930
// module chunks = 0